import { useTranslation } from 'react-i18next';

import { TUseEnumLabelReturnType } from '@/shared/hooks/use-enum-label/use-enum-label.types';
import { UNKNOWN_ENUM_VALUE } from '@/shared/utils/enum/enum.constants';

// Central label resolver for enum values rendered in tables, chips, cells, etc.
// `i18nKeyPrefix` is the namespace + group (e.g. 'projects:sync_status_enum');
// the value is lower-cased to form the key, matching the existing convention.
export const useEnumLabel = (): TUseEnumLabelReturnType => {
  const { t } = useTranslation();

  const getEnumLabel = (
    value: string | null | undefined,
    i18nKeyPrefix?: string,
  ): string => {
    if (!value) return t('common:not_available');

    const key = i18nKeyPrefix
      ? `${i18nKeyPrefix}.${value.toLowerCase()}`
      : undefined;

    // For the UNKNOWN sentinel a feature's own wording wins when it exists,
    // otherwise fall back to the shared "Unknown" label.
    if (value === UNKNOWN_ENUM_VALUE) {
      return key ? t([key, 'common:unknown']) : t('common:unknown');
    }

    return key ? t(key) : value;
  };

  return { getEnumLabel };
};
